import { EditParams } from './EditParams'
import { HiOutlineXMark } from 'react-icons/hi2'

export function ModalEvaluation360({ show, setShow, load, dataTemplate }) {
	return (
		<>
			{show && (
				<div className='tw-w-screen tw-h-screen tw-absolute tw-top-0 tw-left-0 tw-bg-black/50 tw-backdrop-blur-sm tw-flex tw-items-center tw-justify-center tw-pt-[60px]'>
					<div className='tw-bg-white tw-rounded-md tw-flex tw-relative tw-w-[1024px] tw-min-h-[600px] tw-overflow-hidden'>
						<div className='tw-w-full tw-flex-none'>
							<EditParams setShow={setShow} load={load} dataTemplate={dataTemplate} />
						</div>
						<button onClick={() => setShow(false)} className='tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-rounded-full border-0 tw-bg-white hover:tw-bg-gray-100 active:tw-bg-gray-200 tw-absolute tw-top-4 tw-right-4'>
							<HiOutlineXMark size={22} />
						</button>
					</div>
				</div>
			)}
		</>
	)
}
